export interface EmployeePostRequest {
  employeeCode: string;
  name: string;
  password: string;
  isDairen: boolean;
  isAdmin: boolean;
}

export const EmptyEmployeePostRequest: EmployeePostRequest = {
  employeeCode: '',
  name: '',
  password: '',
  isDairen: false,
  isAdmin: false,
};
